<template>
  <div class="seatmap-section-row-seat" :data-seat-id="seat.id" :data-seat-type="seat.type"
    :class="[seat.type, isEmergencySeat ? 'emergency-seat' : '', seatSelected ? 'seatIsSelected' : '', seat.accessible ? 'accessible' : ''] ">
    <a :data-seat-id="seat.id" :data-seat-type="seat.type"
      :class="[seat.type, isEmergencySeat ? 'emergency-seat' : '', seatSelected ? 'seatIsSelected' : '', seat.accessible ? 'accessible' : '']"
      v-if="seat.type != 'gap'"
      :title="'Row: ' + row.label + ', Seat: ' + seat.label + ', Section: ' + section.label + ', Status:  ' + seatStatus + ( seat.accessible ? ', Accessible' : '')  "
      @click.prevent="setPassengerSeat">{{ seatLabel }}</a>
  </div>
</template>
<script>
import { mapGetters, mapState } from "vuex";
export default {
  name: "seatMapSeat",
  props: ["seat", "row", "section", "seatMapId", "scheduleId", "tripId"],
  components: {},
  data() {
    return {};
  },
  computed: {
    seatLabel() {
      if (this.seat.type == "reserved" || this.seat.type == "occupied") {
        return "X";
      } else if (this.seat.type == "gap") {
        return "";
      } else {
        return this.seat.label;
      }
    },
    seatSelected() {
      let seatisselected = this.stateSelectedSeats.findIndex(
        e => e.seatId === this.seat.id && e.tripId === this.tripId
      );
      if (seatisselected === -1) {
        return false;
      } else {
        return true;
      }
    },
    seatSelectable() {
      if (
        this.seat.type == "reserved" ||
        this.seat.type == "blocked" ||
        this.seat.type == "occupied"
      ) {
        return false;
      } else {
        return true;
      }
    },
    seatStatus() {
      if (
        this.seat.type == "reserved" ||
        this.seat.type == "blocked" ||
        this.seat.type == "occupied"
      ) {
        return "Blocked";
      } else {
        return "Available";
      }
    },
    isEmergencySeat() {
      let $emergencySeatsByName = {
        "Coach 1": [
          "1D", "1C", "3B", "3A", "4B", "4A", "7D", "7C", "8D", "8C", "10B", "10A", "11B", "11A"
        ],
        "Coach 2": [
          "1D", "1C", "2D", "2C", "4B", "4A", "5B", "5A", "8D", "8C", "9D", "9C", "11B", "11A", "12B", "12A"
        ],
        "Coach 3": [
          "1D", "1C", "2D", "2C", "4B", "4A", "5B", "5A", "8D", "8C", "9D", "9C", "11B", "11A", "12B", "12A"
        ],
        "Coach 4": [
          "1D", "1C", "2D", "2C", "4B", "4A", "5B", "5A", "8D", "8C", "9D", "9C", "11B", "11A", "12B", "12A"
        ],
        "Coach 5": [
          "1D", "1C", "2D", "2C", "4B", "4A", "5B", "5A", "8D", "8C", "9D", "9C", "11B", "11A", "12B", "12A"
        ],
        "Coach 6": [
          "1D", "1C", "2D", "2C", "4B", "4A", "5B", "5A", "8D", "8C", "9D", "9C", "11B", "11A", "12B", "12A"
        ],
        "Coach 7": [
          "1D", "1C", "2D", "2C", "4B", "4A", "5B", "5A", "8D", "8C", "9D", "9C", "11B", "11A", "12B", "12A"
        ],
        "Coach 8": [
          "1D", "1C", "2D", "2C", "4B", "4A", "5B", "5A", "8D", "8C", "9D", "9C", "11B", "11A", "12B", "12A"
        ],
        "Coach 9": [
          "1D", "1C", "2D", "2C", "4B", "4A", "5B", "5A", "8D", "8C", "9D", "9C", "11B", "11A", "12B", "12A"
        ]
      };
    
      const sectionLabel = this.section.label;
      const seatLabel = this.seat.label;
      return $emergencySeatsByName[sectionLabel].indexOf(seatLabel) > -1 ? true : false;
    },
    ...mapGetters(["stateSelectedSeats"]),
    ...mapState(["seatMapActivePassenger", "passengers"])
  },
  methods: {
    setPassengerSeat: function () {
      if (this.seatMapActivePassenger !== 999 && !this.seatSelected && this.seatSelectable) {
        this.$root.$emit("SEAT_SELECTION", {
          passenger: this.seatMapActivePassenger,
          seat: this.seat,
          row: this.row,
          section: this.section,
          seatMapId: this.seatMapId,
          scheduleId: this.scheduleId,
          tripId: this.tripId
        });
        this.$store.commit("SET_PASSENGER_SEAT", {
          passenger: this.seatMapActivePassenger,
          seat: this.seat,
          row: this.row,
          section: this.section,
          seatMapId: this.seatMapId,
          scheduleId: this.scheduleId,
          tripId: this.tripId
        });
        // If there are more passengers avoid having to click to edit the seat.
        if (this.seatMapActivePassenger < this.passengers.length) {
          this.$store.commit("setSeatMapActivePassenger", this.seatMapActivePassenger + 1);
        } else {
          this.$store.commit("setSeatMapActivePassenger", 999);
        }

      } else {
        alert(this.$t('seat_not_selectable_error'));
      }
    }
  }
};
</script>